import React, { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import { HubHookFormSelect } from "../HubHookFormSelect";
import { UserDetailIcon } from "../UserDetailIcon";
import { HubHookFormInput } from "../HubHookFormInput";
import { useUserHookFormList } from "./useUserHookFormList";

const RenderComponent = ({ id, name, email }) => {
  const user = {
    name,
    email,
    hueShift: id,
  };
  return (
    <UserDetailIcon
      size={16}
      user={user}
      includeEmail={false}
      variant="rounded"
    />
  );
};

export const UsersHookFormSelect = ({
  name = "userId",
  label = "User",
  hideLabel = false,
  required = true,
  customFilter,
  locationId,
  rendered = true,
  includeName,
  CustomRenderComponent = RenderComponent,
  CustomRenderValue = RenderComponent,
  showScrollbar = false,
  ...rest
}) => {
  const { users, isLoading } = useUserHookFormList({ locationId });

  const filterFunction = useCallback((u) => customFilter(u), [customFilter]);
  const filtered = customFilter ? users.filter(filterFunction) : users;

  const defaultProps = {
    ...(!hideLabel ? { label } : {}),
    ...(!locationId && { groupByKey: "location" }),
    ...(rendered && {
      RenderComponent: CustomRenderComponent,
      renderValue: (value) => {
        const user = filtered?.find(({ id }) => id === value);
        return !!user && <CustomRenderValue {...user} />;
      },
    }),
  };

  const { watch } = useFormContext();
  const id = watch(name);
  const userName = filtered?.find((e) => e.id === id)?.name;

  return (
    <>
      <HubHookFormSelect
        name={name}
        options={filtered}
        labelKey="name"
        required={required}
        disabled={isLoading}
        showScrollbar={showScrollbar}
        {...defaultProps}
        {...rest}
      />
      {includeName && (
        <HubHookFormInput name={includeName} defaultValue={userName} hidden />
      )}
    </>
  );
};

export default UsersHookFormSelect;
